import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import store from '@/store';


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { title: '伍號酒店' }
  },
  {
    path: '/about',
    name: 'about',
    meta: { title: '伍號酒店' },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/room',
    name: 'room',
    meta: { title: '伍號酒店' },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/HotelRoomView.vue')
  },
  {
    path: '/artspace',
    name: 'artspace',
    meta: { title: '伍號酒店' },
    component: () => import(/* webpackChunkName: "about" */ '../views/ArtSpaceView.vue')
  },
  {
    path: '/entertainment',
    name: 'entertainment',
    meta: { title: '伍號酒店' },
    component: () => import(/* webpackChunkName: "about" */ '../views/EntertainmentView.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    meta: { title: '伍號酒店' },
    component: () => import(/* webpackChunkName: "about" */ '../views/ContactView.vue')
  },
  {
    path: '/booking',
    name: 'booking',
    meta: { title: '伍號酒店' },
    component: () => import(/* webpackChunkName: "about" */ '../views/BookingView.vue')
  },
  {
    path: '/login',
    name: 'login',
    meta: { title: '伍號酒店' },
    component: () => import(/* webpackChunkName: "about" */ '../views/LoginView.vue')
  },
  {
    path: '/user/orders',
    name: 'order',
    meta: { title: '伍號酒店' },
    component: () => import(/* webpackChunkName: "about" */ '../views/OrderView.vue')
  },
  {
    path: '/user/profile',
    name: 'profile',
    meta: { title: '伍號酒店' },
    component: () => import(/* webpackChunkName: "about" */ '../views/PerCenterView.vue')
  },
  {
    path: '/register',
    name: 'register',
    meta: { title: '伍號酒店' },
    component: () => import(/* webpackChunkName: "about" */ '../views/RegisterView.vue')
  },
  {
    path: '/private',
    name: 'private',
    meta: { title: '伍號酒店' },
    component: () => import(/* webpackChunkName: "about" */ '../views/user/PrivateView.vue')
  },
  {
    path: '/uagreement',
    name: 'uagreement',
    meta: { title: '伍號酒店' },
    component: () => import(/* webpackChunkName: "about" */ '../views/user/UAgreementView.vue')
  },
  {
    path: '/update',
    name: 'update',
    meta: { title: '伍號酒店' },
    component: () => import(/* webpackChunkName: "about" */ '../views/user/UpdateInfoView.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})



router.beforeEach((to, from, next) => {
  store.commit('changeLoad', true)
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next(); // 正确调用 next 函数
});

// 全局后置守卫
router.afterEach(() => {
  // 隐藏加载动画（延迟300ms确保动画效果）
  setTimeout(() => {
    store.commit('changeLoad', false)
  }, 1000);
});

export default router
